<template>
  <div class="thumb autoplay-cell">
    <div class="thumb-image">
      <div>
        <WebpImage :imageInfo="{imageUrl: cellInfo.thumbnail, width: thumbnailInfo.width, height: thumbnailInfo.height, alt: altTitle, className: 'thumb-img'}"/>
      </div>
      <ul class="badge-list">
        <li class="right-top-area" v-common-tag-list="{'badgeList': brandTagList, 'type': 'brand'}"></li>
      </ul>
      <age-limits :target-age="targetAge" :age-tag="ageTag"/>
    </div>
    <div class="sub-title">
      <div class="sub-right" ref="title" v-title-list="{ 'titleList': cellInfo.title_list, 'cellType': 'landscape' }"/>
    </div>
  </div>
</template>

<script>
import CellMixIn from '@/mixins/cell.mixin'
import { titleList, commonTagList } from '@/common/resources/directives'
import AgeLimits from '@/components/model/AgeLimits'
import WebpImage from '@/components/image/WebpImage'
export default {
  name: 'PreviewInstantImageCell',
  components: { WebpImage, AgeLimits },
  mixins: [
    CellMixIn
  ],
  directives: {
    titleList,
    commonTagList
  },
  props: {
    cellInfo: {
      type: Object
    },
    thumbnailInfo: {
      type: Object
    }
  }
}
</script>
<style scoped>
.thumb-image .thumb-img {
  width: 100%;
}
.spinner {
  display: none;
  position: absolute;
  top: 187px;
  right: 8px;
  bottom: auto;
  width: 30px;
  height: 30px;
  font-size: 0;
  text-indent: -99999px;
  animation-iteration-count: infinite;
  z-index: 100;
}
.spinner.on{
  display: block;
}
.loading{
  width: 30px;
  height: 30px;
  background: url(../../../assets/images/common/loading_white.png) no-repeat 0 0;
  background-size: cover;
  -webkit-animation: box 1s steps(12) infinite;
  -moz-animation: box 1s steps(12) infinite;
  animation: box 1s steps(12) infinite;
}
@-webkit-keyframes box {
  from {background-position:0 0}
  to   {background-position:-360px 0}
}

@-moz-keyframes box {
  from {background-position:0 0}
  to   {background-position:-360px 0}
}

@keyframes box {
  from {background-position:0 0}
  to   {background-position:-360px 0}
}
</style>
